import {BulkCommand} from "../../../commands/bulk.command";
import {RecolorIssueStatusCommand} from "../../../commands/recolor-issue-status.command";
import {RenameIssueStatusCommand} from "../../../commands/rename-issue-status.command";
import {IssueStatus} from "../../../domain/entities/issue-status.entity";

/**
 * Builds the update commands for an issue status entity based on the
 * fields that were changed in the edit form.
 *
 * The list of changed fields must be derived BEFORE the form values
 * are written back to the entity, because writing through the entity
 * setters triggers `_setOriginalValue` which clears `entity.changedValues`.
 */
export class IssueStatusUpdateCommandBuilder {

    /**
     * Returns a BulkCommand that wraps the necessary update commands
     * (rename and/or recolor) for the given entity.
     *
     * @param entity         The issue status entity (already mutated with new values)
     * @param changedFields  The list of fields that were modified in the form
     */
    public static build(entity: IssueStatus, changedFields: ReadonlyArray<string>): BulkCommand<IssueStatus> {
        const commands = [];

        if (changedFields.includes(`color`)) {
            commands.push(new RecolorIssueStatusCommand(entity));
        }

        if (changedFields.includes(`key`) || changedFields.includes(`shortcut`)) {
            commands.push(new RenameIssueStatusCommand(entity));
        }

        return new BulkCommand(commands);
    }
}
